import { useEffect, useState, useContext } from "react";
import { toast } from "react-toastify";
import { createShops, updateShops, getBranch, getShops, createSubCompany, updateSubCompany, getSubCompany, BASE_URL } from "../../../Utility/Api";
import { WarehouseContext } from '../../../Utility/UserContext';
import { useLocation } from "react-router-dom";
import { setLocalStorage } from "../../../Utility/function";

export const EditShops = ({ showModal, setShowModal, fetchShops, selectedShops, fetchdata }) => {
    const { showLoader, hideLoader, subCompany, setShopItem, setSubCompany } = useContext(WarehouseContext);
    const location = useLocation();
    const { state } = location;
    const [errors, setErrors] = useState({});
    const [branches, setBranches] = useState([]);
    const [shopsList, setShopsList] = useState([]);
    const [step, setStep] = useState(1); // Step state

    const [formData, setFormData] = useState({
        title: '',
        Address: '',
        phone1: '',
        phone2: '',
        email: '',
        vat_no: '',
        branch_id: state?.branchId || '',
        bank_name: '',
        account_no: '',
        bank_branch: '',
        terms_conditions: '',
        scomp_id: subCompany?.id || ''
    });

    useEffect(() => {
        fetchData();
        setFormData({
            ...formData,
            id: selectedShops?.id,
            title: selectedShops?.title,
            Address: selectedShops?.Address,
            phone1: selectedShops?.phone1,
            phone2: selectedShops?.phone2,
            email: selectedShops?.email,
            vat_no: selectedShops?.vat_no,
            branch_id: selectedShops?.branch_id || '',
            bank_name: selectedShops?.bank_name || '',
            account_no: selectedShops?.account_no || '',
            bank_branch: selectedShops?.bank_branch || '',
            terms_conditions: selectedShops?.terms_conditions || '',
            scomp_id: selectedShops?.scomp_id || subCompany?.id || '',
        });
    }, [selectedShops, subCompany]);

    const fetchData = async () => {
        try {
            const branchdata = await getBranch();
            setBranches(branchdata.data.data);

            const shopData = await getSubCompany();
            if (shopData?.data?.data) {
                setShopsList(shopData.data.data);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const validateStep = () => {
        const validationErrors = {};
        if (step === 1) {
            if (!formData.scomp_id) validationErrors.scomp_id = "Shop selection is required.";
            if (!formData.title?.trim()) validationErrors.title = "Title is required.";
            if (!formData.Address?.trim()) validationErrors.Address = "Address is required.";
            if (formData.email?.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
                validationErrors.email = "Invalid email format.";
            }
            if (formData.phone1 && formData.phone1.length < 8) {
                validationErrors.phone1 = "Phone number must be at least 8 digits long.";
            }
            if (formData.phone2 && formData.phone2.length < 8) {
                validationErrors.phone2 = "Phone number must be at least 8 digits long.";
            }
        } else if (step === 2) {
            // if (!formData.bank_name?.trim()) validationErrors.bank_name = "Bank name is required.";
            // if (!formData.account_no?.trim()) validationErrors.account_no = "Account number is required.";
            // if (!formData.bank_branch?.trim()) validationErrors.bank_branch = "Bank branch is required.";
        } else if (step === 3) {
            // Terms & Conditions are optional
        }

        setErrors(validationErrors);
        return Object.keys(validationErrors).length === 0;
    };

    const handleNext = () => {
        if (validateStep()) {
            setStep((prev) => prev + 1);
        }
    };

    const handlePrev = () => {
        setStep((prev) => prev - 1);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        showLoader();

        if (!validateStep()) {
            hideLoader();
            return;
        }

        const payload = {
            title: formData.title,
            Address: formData.Address,
            phone1: formData.phone1,
            phone2: formData.phone2,
            email: formData.email,
            vat_no: formData.vat_no,
            branch_id: state?.branchId || '',
            bank_name: formData.bank_name,
            account_no: formData.account_no,
            bank_branch: formData.bank_branch,
            terms_conditions: formData.terms_conditions,
            // scomp_id: subCompany?.id,
            scomp_id: formData.scomp_id,
        };

        try {
            if (!selectedShops) {
                const response = await createShops(payload);
                toast.success('Shops Added successfully');
                if (response?.data?.data) {
                    const newBranchData = response.data.data;
                    const newBranch = {
                        ...newBranchData,
                        shop_id: newBranchData.id,
                        shop_title: newBranchData.title
                    };
                    const chosenSubCompany = shopsList.find(s => String(s.id) === String(formData.scomp_id));
                    if (chosenSubCompany) {
                        setLocalStorage("SUB-COMPANY", JSON.stringify(chosenSubCompany));
                        setSubCompany(chosenSubCompany);
                    }
                    setLocalStorage("SHOP", JSON.stringify(newBranch));
                    setShopItem(newBranch);
                    window.location.reload();
                }
            } else {
                const response = await updateShops(selectedShops?.id, payload);
                toast.success('Shops Updated successfully');
                if (response?.data?.data) {
                    const updatedBranchData = response.data.data;
                    const currentShop = JSON.parse(sessionStorage.getItem("SHOP"));
                    if (currentShop && String(currentShop.shop_id) === String(updatedBranchData.id)) {
                        const updatedBranch = {
                            ...updatedBranchData,
                            shop_id: updatedBranchData.id,
                            shop_title: updatedBranchData.title
                        };
                        setLocalStorage("SHOP", JSON.stringify(updatedBranch));
                        setShopItem(updatedBranch);
                        window.location.reload();
                    }
                }
            }
            hideLoader();
            handleclear()
            fetchdata();
            // fetchShops();
        } catch (error) {
            console.error('Error in Shops data:', error);
            hideLoader();
            const errorMessage = error.response?.data?.message || "An unexpected error occurred. Please try again.";
            toast.error(errorMessage);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
        setErrors((prev) => ({
            ...prev,
            [name]: "",
        }));
    };

    const handleclear = () => {
        setStep(1);
        setShowModal(false);
        setErrors({});
        setFormData({
            title: '',
            Address: '',
            phone1: '',
            phone2: '',
            email: '',
            vat_no: '',
            branch_id: state?.branchId || '',
            bank_name: '',
            account_no: '',
            bank_branch: '',
            terms_conditions: '',
            scomp_id: subCompany?.id || ''
        });
    };


    return (
        <>
            {showModal && (
                <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header border-0">
                                <h5 className="modal-title">{selectedShops ? 'Edit Branch' : 'Add Branch'}</h5>
                                <button type="button" className="btn-close" aria-label="Close" onClick={() => handleclear()}></button>
                            </div>
                            <div className="modal-body">
                                <form onSubmit={handleSubmit}>
                                    {step === 1 && (
                                        <>
                                            <div className="form-group mb-3">
                                                <label>Select Shop <span className="text-danger">*</span></label>
                                                <select
                                                    name="scomp_id"
                                                    value={formData.scomp_id}
                                                    onChange={handleChange}
                                                    className="form-select"
                                                >
                                                    <option value="">Choose a Shop...</option>
                                                    {shopsList.map((shop) => (
                                                        <option key={shop.id} value={shop.id}>
                                                            {shop.title}
                                                        </option>
                                                    ))}
                                                </select>
                                                {errors.scomp_id && <small className="text-danger">{errors.scomp_id}</small>}
                                            </div>

                                            <div className="form-group mb-3">
                                                <label>Title</label>
                                                <input
                                                    type="text"
                                                    name="title"
                                                    value={formData.title}
                                                    onChange={handleChange}
                                                    className="form-control"
                                                />
                                                {errors.title && <small className="text-danger">{errors.title}</small>}
                                            </div>

                                            <div className="form-group mb-3">
                                                <label>Address</label>
                                                <input
                                                    type="text"
                                                    name="Address"
                                                    value={formData.Address}
                                                    onChange={handleChange}
                                                    className="form-control"
                                                />
                                                {errors.Address && <small className="text-danger">{errors.Address}</small>}
                                            </div>

                                            <div className="form-group mb-3">
                                                <label>Phone 1</label>
                                                <input
                                                    type="number"
                                                    name="phone1"
                                                    value={formData.phone1}
                                                    onChange={handleChange}
                                                    className="form-control"
                                                />
                                                {errors.phone1 && <small className="text-danger">{errors.phone1}</small>}
                                            </div>

                                            <div className="form-group mb-3">
                                                <label>Phone 2</label>
                                                <input
                                                    type="number"
                                                    name="phone2"
                                                    value={formData.phone2}
                                                    onChange={handleChange}
                                                    className="form-control"
                                                />
                                                {errors.phone2 && <small className="text-danger">{errors.phone2}</small>}
                                            </div>

                                            <div className="form-group mb-3">
                                                <label>Email</label>
                                                <input
                                                    type="text"
                                                    name="email"
                                                    value={formData.email}
                                                    onChange={handleChange}
                                                    className="form-control"
                                                />
                                                {errors.email && <small className="text-danger">{errors.email}</small>}
                                            </div>
                                        </>
                                    )}

                                    {step === 2 && (
                                        <>
                                            <div className="form-group mb-3">
                                                <label>Bank Name</label>
                                                <input
                                                    type="text"
                                                    name="bank_name"
                                                    value={formData.bank_name}
                                                    onChange={handleChange}
                                                    className="form-control"
                                                />
                                                {errors.bank_name && <small className="text-danger">{errors.bank_name}</small>}
                                            </div>

                                            <div className="form-group mb-3">
                                                <label>Account Number</label>
                                                <input
                                                    type="number"
                                                    name="account_no"
                                                    value={formData.account_no}
                                                    onChange={handleChange}
                                                    className="form-control"
                                                />
                                                {errors.account_no && <small className="text-danger">{errors.account_no}</small>}
                                            </div>

                                            <div className="form-group mb-3">
                                                <label>Bank Branch</label>
                                                <input
                                                    type="text"
                                                    name="bank_branch"
                                                    value={formData.bank_branch}
                                                    onChange={handleChange}
                                                    className="form-control"
                                                />
                                                {errors.bank_branch && <small className="text-danger">{errors.bank_branch}</small>}
                                            </div>


                                            <div className="form-group mb-3">
                                                <label>Vat Number</label>
                                                <input
                                                    type="text"
                                                    name="vat_no"
                                                    value={formData.vat_no}
                                                    onChange={handleChange}
                                                    className="form-control"
                                                />
                                                {errors.vat_no && <small className="text-danger">{errors.vat_no}</small>}
                                            </div>
                                        </>
                                    )}

                                    {step === 3 && (
                                        <>
                                            <div className="form-group mb-3">
                                                <label>Terms & Conditions</label>
                                                <textarea
                                                    name="terms_conditions"
                                                    value={formData.terms_conditions}
                                                    onChange={handleChange}
                                                    className="form-control"
                                                    rows="3"
                                                ></textarea>
                                                {errors.terms_conditions && <small className="text-danger">{errors.terms_conditions}</small>}
                                            </div>
                                        </>
                                    )}

                                    <div className="mt-5">
                                        {step > 1 && <button type="button" className="btn btn-secondary me-2" onClick={handlePrev}>Previous</button>}
                                        {step < 3 && (
                                            <button type="button" className="btn btn-primary" onClick={handleNext}>Next</button>
                                        )}
                                        {step == 3 && (
                                            step == 3 && <button type="submit" className="btn btn-success">Submit</button>
                                        )}
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export const AddorEditSubCompany = ({ showModal, setShowModal, fetchShops, selectedShops, fetchdata }) => {
    const { showLoader, hideLoader, parentCompany, setShopItem, setSubCompany } = useContext(WarehouseContext);
    const location = useLocation();
    const { state } = location;
    const [errors, setErrors] = useState({});
    const [logo, setLogo] = useState(null);
    const [logo1, setLogo1] = useState(null);

    const [formData, setFormData] = useState({
        title: '',
        status: '1',
        para_id: parentCompany?.parent_company_id || "1",
    });

    useEffect(() => {
        setFormData({
            ...formData,
            id: selectedShops?.id,
            title: selectedShops?.title || '',
            status: selectedShops?.status !== undefined && selectedShops?.status !== null ? String(selectedShops?.status) : '1',
            para_id: parentCompany?.parent_company_id || "1",
        });
        if (selectedShops?.logo) {
            setLogo1(BASE_URL + selectedShops?.logo)
        } else {
            setLogo1(null)
        }
    }, [selectedShops]);

    const validateStep = () => {
        const validationErrors = {};
        if (!formData.title?.trim()) validationErrors.title = "Title is required.";
        setErrors(validationErrors);
        return Object.keys(validationErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        showLoader();

        if (!selectedShops?.id && !validateStep()) {
            hideLoader();
            return;
        }

        try {
            const payload = new FormData();
            payload.append("title", formData.title);
            payload.append("status", formData.status);
            payload.append("para_id", formData.para_id);

            if (logo) {
                payload.append("logo", logo);
            }

            if (!selectedShops) {
                const response = await createSubCompany(payload);
                toast.success('Shop Added successfully');
                if (response?.data?.data) {
                    const newSubCompany = response.data.data;
                    setLocalStorage("SUB-COMPANY", JSON.stringify(newSubCompany));
                    setSubCompany(newSubCompany);
                    setLocalStorage("SHOP", "null");
                    setShopItem(null);
                    window.location.reload();
                }
            } else {
                const response = await updateSubCompany(selectedShops?.id, payload);
                toast.success('Shop Updated successfully');
                if (response?.data?.data) {
                    const updatedSubCompany = response.data.data;
                    const currentSubCompany = JSON.parse(sessionStorage.getItem("SUB-COMPANY"));
                    if (currentSubCompany && String(currentSubCompany.id) === String(updatedSubCompany.id)) {
                        setLocalStorage("SUB-COMPANY", JSON.stringify(updatedSubCompany));
                        setSubCompany(updatedSubCompany);
                        window.location.reload();
                    }
                }
            }

            hideLoader();
            handleclear();
            fetchdata();
        } catch (error) {
            console.error('Error in Shops data:', error);
            hideLoader();
            if (
                error.response &&
                error.response.data &&
                error.response.data.errors &&
                error.response.data.errors.title
            ) {
                toast.error(error.response.data.errors.title[0]);
            } else if (error.response && error.response.data && error.response.data.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("An unexpected error occurred. Please try again.");
            }
        }
    };

    const handleChange = (e) => {
        const { name, value, type } = e.target;

        if (type === "file") {
            setLogo(e.target.files[0]);
        } else {
            setFormData({
                ...formData,
                [name]: value,
            });
        }

        setErrors((prev) => ({
            ...prev,
            [name]: "",
        }));
    };

    const handleclear = () => {
        setShowModal(false);
        setErrors({});
        setFormData({
            title: '',
            status: '1',
            para_id: parentCompany?.parent_company_id || "1",
        });
        setLogo(null);
    };

    return (
        <>
            {showModal && (
                <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header border-0">
                                <h5 className="modal-title">{selectedShops ? 'Edit Shop' : 'Add Shop'}</h5>
                                <button type="button" className="btn-close" aria-label="Close" onClick={handleclear}></button>
                            </div>
                            <div className="modal-body">
                                <form onSubmit={handleSubmit}>
                                    {/* Title Input */}
                                    <div className="form-group mb-3">
                                        <label>Title</label>
                                        <input
                                            type="text"
                                            name="title"
                                            value={formData.title}
                                            onChange={handleChange}
                                            className="form-control"
                                        />
                                        {errors.title && <small className="text-danger">{errors.title}</small>}
                                    </div>

                                    {/* Type Dropdown Selection */}
                                    <div className="form-group mb-3">
                                        <label>Type</label>
                                        <select
                                            name="status"
                                            value={formData.status}
                                            onChange={handleChange}
                                            className="form-select"
                                        >
                                            <option value="0">Common</option>
                                            <option value="1">Factory</option>
                                        </select>
                                    </div>

                                    {/* Logo Upload */}
                                    <div className="form-group mb-3">
                                        <label>Upload Logo</label>
                                        <input
                                            type="file"
                                            accept="image/*"
                                            name="logo"
                                            onChange={handleChange}
                                            className="form-control"
                                        />
                                        {logo && (
                                            <div className="mt-2">
                                                <img src={URL.createObjectURL(logo)} alt="Logo Preview" style={{ width: "100px", height: "100px", objectFit: "cover", borderRadius: "5px" }} />
                                            </div>
                                        )}
                                        {!logo && logo1 && (
                                            <div className="mt-2">
                                                <img src={logo1} alt="Logo Preview" style={{ width: "100px", maxHeight: "100px", objectFit: "cover", borderRadius: "5px" }} />
                                            </div>
                                        )}
                                    </div>

                                    <div className="mt-5">
                                        <button type="submit" className="btn btn-success">Submit</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

